import React, { useEffect, useState } from 'react';
import { Sparkles } from 'lucide-react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../utils/AuthContext';

function validateLoginForm(form) {
  const nextErrors = { email: '', password: '' };

  if (!form.email.trim()) {
    nextErrors.email = 'Podaj adres email.';
  } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(form.email.trim())) {
    nextErrors.email = 'Podaj poprawny adres email.';
  }

  if (!form.password) {
    nextErrors.password = 'Podaj hasło.';
  } else if (form.password.length < 6) {
    nextErrors.password = 'Hasło powinno mieć co najmniej 6 znaków.';
  }

  return nextErrors;
}

export default function LoginPage() {
  const { login, isLoggedIn } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({ email: '', password: '' });
  const [fieldErrors, setFieldErrors] = useState({ email: '', password: '' });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (isLoggedIn) {
      navigate('/panel', { replace: true });
    }
  }, [isLoggedIn, navigate]);

  async function handleSubmit(e) {
    e.preventDefault();
    const nextErrors = validateLoginForm(form);
    setFieldErrors(nextErrors);
    if (nextErrors.email || nextErrors.password) {
      setError('Popraw zaznaczone pola.');
      return;
    }

    setError('');
    setLoading(true);

    try {
      await login(form.email, form.password);
      navigate('/panel', { replace: true });
    } catch (err) {
      setError(err.response?.data?.error || 'Błąd logowania. Sprawdź dane.');
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="login-page">
      <div className="login-card">
        <div className="login-logo">
          <Sparkles size={22} strokeWidth={1.8} />
        </div>
        <p className="login-kicker">Panel ClientWay</p>
        <h1 className="login-title">ClientWay</h1>
        <p className="login-subtitle">Zaloguj się do panelu i zarządzaj rezerwacjami, klientami i planem dnia w jednym miejscu.</p>

        {error && <div className="alert alert-error">{error}</div>}

        <form onSubmit={handleSubmit} className="login-form">
          <div className="form-group">
            <label htmlFor="email">Email</label>
            <input
              id="email"
              type="email"
              placeholder="twoj@email.pl"
              value={form.email}
              onChange={(e) => {
                setForm({ ...form, email: e.target.value });
                setFieldErrors((prev) => ({ ...prev, email: '' }));
                setError('');
              }}
              className={fieldErrors.email ? 'input-error' : ''}
              aria-invalid={fieldErrors.email ? 'true' : 'false'}
              autoComplete="email"
              required
            />
            {fieldErrors.email && <p className="field-error">{fieldErrors.email}</p>}
          </div>
          <div className="form-group">
            <label htmlFor="password">Hasło</label>
            <input
              id="password"
              type="password"
              placeholder="••••••••"
              value={form.password}
              onChange={(e) => {
                setForm({ ...form, password: e.target.value });
                setFieldErrors((prev) => ({ ...prev, password: '' }));
                setError('');
              }}
              className={fieldErrors.password ? 'input-error' : ''}
              aria-invalid={fieldErrors.password ? 'true' : 'false'}
              autoComplete="current-password"
              required
            />
            {fieldErrors.password && <p className="field-error">{fieldErrors.password}</p>}
          </div>
          <button type="submit" className="btn-primary" disabled={loading}>
            {loading ? 'Logowanie...' : 'Zaloguj się'}
          </button>
        </form>

        <p className="auth-switch-copy auth-switch-copy--tight">
          <Link to="/forgot-password" className="auth-switch-link">Nie pamiętasz hasła?</Link>
        </p>

        <p className="auth-switch-copy">
          Nie masz jeszcze konta? <Link to="/register" className="auth-switch-link">Załóż konto</Link>
        </p>
      </div>
    </div>
  );
}
